import {ACTIONS} from "@intellectability/platform-common/constants";

/** @type {import("@intellectability/platform-common/router").RouterConfig} */
const routerConfig = {
    spa: false,
    appPath: "index.php",
    routes: [
        {
            layout: "null",
            path: `?action=${ACTIONS.CHECKLISTS_SMM_GLOBAL_LIST}`,
            render: () => import("../../Pages/Nursing/SelfManagementOfMedication/List/SelfManagementOfMedicationList.svelte"),
            title: "SMMs List"
        }
    ]
};

export default routerConfig;

